// extracted by mini-css-extract-plugin
module.exports = {"root":"_2AhdT","uui-spinner":"_1PPK5","uuiSpinner":"_1PPK5"};